<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="train-container noselect train-top-icon {{outerBorderClass}} {{innerBackgroundColor}}" *ngIf="!isDefaultTrainIcon">
	<div class="train-icon-left">
		<p class="trainId {{innerTextColor}}">{{trainId}}</p>
		<p class="row-2 {{innerTextColor}}">  {{trainIdOfPlannedPowerFromTrain1}}</p>
		<p class="row-3 {{innerTextColor}}">  {{trainIdOfPlannedPowerFromTrain2}}</p>
		<p class="row-4 {{innerTextColor}}">{{trainHasNotes}}</p>
	</div>
	<div class="train-icon-center">
		<p class="row-2 {{innerTextColor}}">{{status}}</p>
		<p class="row-3 {{innerTextColor}}">{{associatedStatusTime}}</p>
		<p class="row-4 {{innerTextColor}}">{{upsTrainText}}</p>
	</div>	
	<div class="train-icon-right">
		<p class="row-1 {{innerTextColor}}" *ngIf="isPtcIndicator">PTC</p>
		<p class="row-2 {{innerTextColor}}">{{trainTonnage}}</p>
		<p class="row-3 {{innerTextColor}}">{{calculatedTonnage}}</p>
		<p class="row-4 {{innerTextColor}}">{{(locomotiveAssignedToTrain)? locomotiveAssignedToTrain : '0'}}</p>
		
		<span class="white-ver-bdr"></span> </div>
</div>

<svg version="1.1" class="train-na-icon" id="Layer_1" *ngIf="isDefaultTrainIcon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
 x="0px" y="0px" viewBox="0 0 500 117.8" style="enable-background:new 0 0 500 117.8;" xml:space="preserve">
	<g>
		<rect x="83" y="35" class="st0" width="7" height="19" />
		<rect x="94" y="35" class="st0" width="6" height="19" />
		<path class="st0" d="M410,91.4V91h5v-1h4v-3h-14C407,88.1,408.7,89.6,410,91.4z" />
		<path class="st0" d="M268,36h-29c-0.6,0-1,0.4-1,1v15c0,0.6,0.4,1,1,1h29c0.6,0,1-0.4,1-1V37C269,36.4,268.6,36,268,36z" />
		<path class="st0" d="M341,36h-29c-0.6,0-1,0.4-1,1v15c0,0.6,0.4,1,1,1h29c0.6,0,1-0.4,1-1V37C342,36.4,341.6,36,341,36z" />
		<circle class="st0" cx="396.9" cy="101.3" r="7.3" />
		<path class="st0" d="M232,36h-29c-0.6,0-1,0.4-1,1v15c0,0.6,0.4,1,1,1h29c0.6,0,1-0.4,1-1V37C233,36.4,232.6,36,232,36z" />
		<path class="st0" d="M305,36h-29c-0.6,0-1,0.4-1,1v15c0,0.6,0.4,1,1,1h29c0.6,0,1-0.4,1-1V37C306,36.4,305.6,36,305,36z" />
		<path class="st0" d="M195,36h-29c-0.6,0-1,0.4-1,1v15c0,0.6,0.4,1,1,1h29c0.6,0,1-0.4,1-1V37C196,36.4,195.6,36,195,36z" />
		<circle class="st0" cx="96.3" cy="101.3" r="7.3" />
		<path class="st0" d="M74,90h5v1h4v0.7c1.3-1.7,2.8-3.7,4.7-4.7H74V90z" />
		<path class="st0" d="M158,36h-29c-0.6,0-1,0.4-1,1v15c0,0.6,0.4,1,1,1h29c0.6,0,1-0.4,1-1V37C159,36.4,158.6,36,158,36z" />
		<circle class="st0" cx="458.5" cy="101.3" r="7.3" />
		<path class="st0" d="M21,27h55v49h31V27h370v-3H21V27z M78,27h27v47H78V27z" />
		<circle class="st0" cx="34.7" cy="101.3" r="7.3" />
		<path class="st0" d="M439,53c0.6,0,1-0.4,1-1V37c0-0.6-0.4-1-1-1h-29c-0.6,0-1,0.4-1,1v15c0,0.6,0.4,1,1,1H439z" />
		<path class="st0" d="M57,87H43.4c1.6,1,3,2.5,4.2,4H52v-1h5V87z" />
		<path class="st0" d="M65,50c0.6,0,1-0.4,1-1V37c0-0.6-0.4-1-1-1H51c-0.6,0-1,0.4-1,1v12c0,0.6,0.4,1,1,1H65z" />
		<path class="st0" d="M436,90h5v1h4.7c1.3-1.6,2.9-3,4.7-4H436V90z" />
		<rect x="420" y="95" class="st0" width="16" height="9" />
		<rect x="57" y="95" class="st0" width="16" height="9" />
		<path class="st1" d="M496,75v-1h-7v3h-3V18h-7V4H362V1.2c0-0.6,0-1.2-0.6-1.2h-8.3c-0.5,0-1.1,0.7-1.1,1.2V4h-27V1.2
		c0-0.6-0.9-1.2-1.5-1.2h-8.3c-0.6,0-1.2,0.7-1.2,1.2V4H20v14h-6v59h-3v-3H4v1H0v11h4v1h7v-3h6v-3h3v6h6c-4.7,3-7.8,8.2-7.8,14.2
		c0,9.1,7.4,16.6,16.5,16.6c7.1,0,13.1-4.5,15.5-10.8l2.7,2h26.7l1.4-1.8c2.4,6.2,8.4,10.6,15.4,10.6c9.1,0,16.5-7.5,16.5-16.6
		c0-5.9-3.1-11.2-7.8-14.2h283.8c-5,2.8-8.3,8.2-8.3,14.3c0,9.1,7.4,16.5,16.5,16.5c7.2,0,13.3-4.6,15.5-11.1l2.6,2.3h26.7l1.5-1.6
		c2.4,6.1,8.4,10.3,15.3,10.3c9.1,0,16.5-7.4,16.5-16.5c0-6.1-3.4-11.5-8.3-14.3H479v-6h4v3h6v3h7v-1h4V75H496z M34.7,108.7
		c-4.1,0-7.3-3.3-7.3-7.3s3.3-7.3,7.3-7.3c4.1,0,7.3,3.3,7.3,7.3S38.8,108.7,34.7,108.7z M52,90v1h-4.5c-1.2-1.5-2.6-3-4.2-4H57v3
		H52z M50,49V37c0-0.6,0.4-1,1-1h14c0.6,0,1,0.4,1,1v12c0,0.6-0.4,1-1,1H51C50.4,50,50,49.6,50,49z M73,104H57v-9h16V104z M83,91.7
		V91h-4v-1h-5v-3h13.7C85.8,88,84.3,89.9,83,91.7z M96.3,108.7c-4.1,0-7.3-3.3-7.3-7.3s3.3-7.3,7.3-7.3c4.1,0,7.3,3.3,7.3,7.3
		S100.4,108.7,96.3,108.7z M159,52c0,0.6-0.4,1-1,1h-29c-0.6,0-1-0.4-1-1V37c0-0.6,0.4-1,1-1h29c0.6,0,1,0.4,1,1V52z M196,52
		c0,0.6-0.4,1-1,1h-29c-0.6,0-1-0.4-1-1V37c0-0.6,0.4-1,1-1h29c0.6,0,1,0.4,1,1V52z M233,52c0,0.6-0.4,1-1,1h-29c-0.6,0-1-0.4-1-1
		V37c0-0.6,0.4-1,1-1h29c0.6,0,1,0.4,1,1V52z M269,52c0,0.6-0.4,1-1,1h-29c-0.6,0-1-0.4-1-1V37c0-0.6,0.4-1,1-1h29c0.6,0,1,0.4,1,1
		V52z M306,52c0,0.6-0.4,1-1,1h-29c-0.6,0-1-0.4-1-1V37c0-0.6,0.4-1,1-1h29c0.6,0,1,0.4,1,1V52z M342,52c0,0.6-0.4,1-1,1h-29
		c-0.6,0-1-0.4-1-1V37c0-0.6,0.4-1,1-1h29c0.6,0,1,0.4,1,1V52z M396.9,108.7c-4.1,0-7.3-3.3-7.3-7.3s3.3-7.3,7.3-7.3
		c4.1,0,7.3,3.3,7.3,7.3S400.9,108.7,396.9,108.7z M419,90h-4v1h-5v0.4c-1.3-1.8-3-3.3-5-4.4h14V90z M409,52V37c0-0.6,0.4-1,1-1h29
		c0.6,0,1,0.4,1,1v15c0,0.6-0.4,1-1,1h-29C409.4,53,409,52.6,409,52z M436,104h-16v-9h16V104z M445.7,91H441v-1h-5v-3h14.4
		C448.6,88,447,89.4,445.7,91z M458.5,108.7c-4.1,0-7.3-3.3-7.3-7.3s3.3-7.3,7.3-7.3c4.1,0,7.3,3.3,7.3,7.3S462.6,108.7,458.5,108.7
		z M473,77h-17V31h17V77z M473,27H107v49H76V27H25v-3h448V27z" />
		<path class="st1" d="M105,27H78v47h27V27z M90,54h-7V35h7V54z M100,54h-6V35h6V54z" />
	</g>
	<text transform="matrix(1 0 0 1 224.1923 68.2904)" class="st2 st3" font-family="Lato, Arial" style="font-family:Lato, arial; font-size: 60px; ">N/A</text>
</svg>